import React, { Component } from 'react';
import './style.scss'
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter,
    Col, Row, Card, CardBody, Form, FormGroup, Label, Input
} from 'reactstrap';
import fileSaver from 'file-saver';
import { connect } from 'react-redux';
import AuthService from '../../../components/Services/AuthService';
import { Preloading } from '../../../components/UI/Preloader/action';
class CreateRiskFactorComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRiskType: '',
            errorMessage: ''
        };
        this.Auth = new AuthService();
    }

    handleRiskTypeChange = (event) => {
        event.preventDefault();
        this.setState({
            selectedRiskType: event.target.value,
        });
    }
    downloadExcel = (event) => {
        event.preventDefault();
        const selectedId = null;
        this.Auth.downloadExcel(selectedId)
            .then((response) => {
                var blob = new Blob([response.data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, 'Create_Riskfactor_Template.xlsx');
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        this.handleAuthorization();
                    }
                }
            });
    }

    uploadExcel = (event) => {
        event.preventDefault();
        this.props.preloading(true)
        const selectedId = undefined;
        this.Auth.uploadExcel(event.target.files[0], selectedId)
            .then((response) => {
                this.props.preloading(false)
                this.saveSuccessful();
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        this.props.preloading(false)
                        this.toggleModal();
                    } else if (error.response.status === 500) {
                        this.props.preloading(false)
                        this.duplicateRiskFactor(error.response.data);
                    }
                }
            });
        event.target.value = null;
    }
    handleAuthorization = () => {
        this.setState({
            modal: !this.state.modal
        });
    }
    saveSuccessful = () => {
        this.setState({
            saveSuccess: !this.state.saveSuccess
        })
    }
    toggleModal = () => {
        this.setState({
            modal: !this.state.modal
        });
    }
    duplicateRiskFactor = (errorMessage) => {
        this.setState({
            sameRiskFactor: !this.state.sameRiskFactor,
            errorMessage: errorMessage.message
        })
    }
    handleLogout = () => {
        this.Auth.logout();
        this.props.history.replace('/login');
    }
    render() {
        return (
            <Col>
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">Create Risk Factor</h4>
                        </div>
                        <Card>
                            <CardBody>
                                <Form className="w-70">
                                    <FormGroup className="position-relative">
                                        {/* <Label for="risk-type">Risk Type</Label>
                                        <Row className="mb-3">
                                            <Col xs="20">
                                                <Input id="risk-type" type="select" name="select" className="form-control select-risk" onChange={this.handleRiskTypeChange}>
                                                    <option value="">Select</option>
                                                    <option value="qualitative">Qualitative</option>
                                                    <option value="quantitative">Quantitative</option>
                                                </Input>
                                            </Col>
                                        </Row> */}
                                        <Row>
                                            <Col xs="20">
                                                <Button color="primary" title="Download New Risk Factor Template" onClick={this.downloadExcel}><i className="fa fa-download"></i>&nbsp;Download Risk Factor Template </Button>
                                                <div color="primary" className="btn btn-primary ml-3 position-relative" title="Upload New Risk Factor">
                                                    {/* <div> */}
                                                    <input onChange={this.uploadExcel} type="file" name="file" id="file" className="upload-file" title="Upload New Risk Factor" />
                                                    <i className="fa fa-upload"></i>&nbsp;Upload Risk Factor Template
                                                    {/* </div> */}
                                                </div>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Authorization Error 401</ModalHeader>
                    <ModalBody>
                        Authorization Error Click Next to Logout
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" onClick={this.handleLogout}>Logout</Button>{' '}
                        {/* <Button color="secondary" onClick={this.toggle}>Cancel</Button> */}
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.saveSuccess} className={this.props.className}>
                    <ModalHeader toggle={this.saveSuccessful}>Success</ModalHeader>
                    <ModalBody>
                        Risk Factor Added Successfully
                    </ModalBody>
                    <ModalFooter>
                        {/* <Button color="primary" onClick={this.handleLogout}>Logout</Button>{' '} */}
                        <Button color="info" onClick={this.saveSuccessful}>Close</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.sameRiskFactor} className={this.props.className}>
                    <ModalHeader toggle={this.duplicateRiskFactor}>Warning</ModalHeader>
                    <ModalBody>
                        {this.state.errorMessage}
                    </ModalBody>
                    <ModalFooter>
                        {/* <Button color="primary" onClick={this.handleLogout}>Logout</Button>{' '} */}
                        <Button color="info" onClick={this.duplicateRiskFactor}>Close</Button>
                    </ModalFooter>
                </Modal>
            </Col>
        );
    }
}
const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateRiskFactorComponent);
